<template>
  <div
    class="bg bg-image about-us_bg-img"
  >
    <b-container class="about-us p-t-20-rem main-container">
      <b-row>
        <b-col
          md="8"
          sm="12"
        >
          <h2 class="about-us_title white m-b-40">
            About Us
          </h2>
          <p class="about-us_text l-h-22 white m-b-50">
            STATECS is a data-driven organization set to improve
            the healthcare and medical system worldwide
          </p>
          <b-btn
            class="btn-main-bg-blue white mr-3 mb-3"
            @click="$router.push({
              name: R_ABOUT_US,
            })"
          >
            About Us
          </b-btn>
          <b-btn
            class="btn-main-bg-blue white mr-3 mb-3"
            @click="$router.push({
              name: R_CONTACT_US,
            })"
          >
            Contact Us
          </b-btn>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { R_ABOUT_US, R_CONTACT_US } from '@/router/routes';

export default {
  name: 'Start',
  data() {
    return {
      R_ABOUT_US,
      R_CONTACT_US,
    };
  },
};
</script>
